import { algorithms } from '@helpers/types';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

interface IAlgorithmSelectorProps {
  value: algorithms;
  onChange: (value: algorithms) => void;
}

const AlgorithmSelector = (props: IAlgorithmSelectorProps) => {
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="algorithm-select-label">Heuristica</InputLabel>
      <Select
        labelId="algorithm-select-label"
        id="algorithm-select"
        value={props.value}
        label="Algoritmo"
        onChange={(event) => props.onChange(event.target.value as algorithms)}
      >
        <MenuItem value={algorithms.k_means}>Agrupamiento Inteligente</MenuItem>
        <MenuItem value={algorithms.or_tools}>
          Optimización Estocástica
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default AlgorithmSelector;
